const timer = {
    init: function () {
		const countdownTimers = [...document.querySelectorAll('.timer-countdown')]
		timer.timers = new Array();
		countdownTimers.map(countdownTimer => {
			if (countdownTimer.dataset.countdown) {
				timer.timers.push({ 
					element: countdownTimer, 
					endTime: new Date().getTime() + Number(countdownTimer.dataset.countdown) 
				});
			}
		});
		timer.updateTimers();
		setInterval(timer.updateTimers, 1000);
	},

	updateTimers: function() {
		timer.timers.map(timerItem => {
			var now = new Date().getTime();
			var distance = timerItem.endTime - now;
			var el = timerItem.element;

			var days = Math.floor(distance / (1000 * 60 * 60 * 24));
			var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
			var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
			var seconds = Math.floor((distance % (1000 * 60)) / 1000);

			if(el.classList.contains('cta-countdown')) {
				days = days.toString().split('');
				hours = hours.toString().split('');
				minutes = minutes.toString().split('');
				seconds = seconds.toString().split('');

				days = timer.countMap(days);
				hours = timer.countMap(hours);
				minutes = timer.countMap(minutes);
				seconds = timer.countMap(seconds);

				el.innerHTML = '<div class="cta-timer-container">' + (days > 0 ? '<div><span class="cta-timer-count">'+days + '</span><span>days</span></div>' : '') + '<div><span class="cta-timer-count">'+hours + '</span><span>hours</span></div>' + '<div><span class="cta-timer-count">' + minutes + '</span><span>minutes</span></div>' + (days <= 0 ? '<div><span class="cta-timer-count">' + seconds + '</span><span class="count-units">seconds</span></div>' : '') + '</div>'
			} 
			else {
				// Display the result in the element with id="demo"
				el.innerHTML = `
					${days > 0 
						? days + (days != 1 ? ' days, ' : ' day, ') + hours + (hours != 1 ? ' hrs' : ' hr')
							: (hours > 0
							? hours + (hours != 1 ? ' hrs, ' : ' hr, ') + minutes + (minutes != 1 ? ' mins' : ' min') 
						: minutes + (minutes != 1 ? ' mins, ' : ' min, ') + seconds + (seconds != 1 ? ' secs' : ' sec')
						)
					}
				`;
			}

			// If the count down is finished, write some text 
			if (distance < 0) {
				//clearInterval(x);
				el.innerHTML = 'EXPIRED';
			}
		});
	},

	countMap: function(elmap){
		return elmap.map(function(num){
			return num;
		}).join('');
	}
}

export default timer


// WEBPACK FOOTER //
// ./assets/src/js/classes/timer.js